export const MAX_VISIBLE_TOASTS = 3;

export const TOAST_DURATION_MS = 5000;
